import { useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { FaTimes } from 'react-icons/fa';

import {
    addHashToHexColor,
    applyImportantStyles,
    getCookie,
    getsessionStorageData,
} from '../../lib';
import { sessionStorageKeys } from '../../constants';
import './PredifinedPopUp.css';
import { Input } from 'components/common/input';
import { COOKIE_NAME } from 'config';
import { isEmpty } from 'lodash';
import axios from 'axios';
import { useGetBookingData } from 'hooks';
import { toast } from 'react-toastify';
import { Checkbox } from 'components/common/checkbox';

const PredifinedPopUp = ({
    props: {
        popupTopImage: imageUrl,
        popupTitle: title,
        popupText: desc,
        popupButton1Text: btnText,
        popupButton1Link: btnUrl,
        popupID,
        popupWidth,
        popupHeight,
        popupBorderRadius,
        popupBorderColor,
        popupBackgroundColor,
        popupVerticalAlign = 'top',
        popupHorrizontalAlign = 'left',

        popupCloseButtonColor,
        popupCloseButtonBackgroundColor,

        popupButton1Background,
        popupButton1FontColor,
        popupButton1BorderColor,
        popupButton1FontSize,

        popupOpenInterval,
        textboxPlaceHolder,
        textboxPlaceHolder2,
        termsAndConditionsUrl,
        popupButton1MessageAfterPress,
        imageTopMargin: topMargin,
        popupBottomMargin: bottomMargin,
        popupLeftMargin: leftMargin,
        popupRightMargin: rightMargin,
    },
    extraClass = '',
}) => {
    const closedOfferPopups = getsessionStorageData(
        sessionStorageKeys.CLOSED_OFFER_POPUPS,
        []
    );
    const data = useSelector((state) => state.miniBookingWidget?.data);
    const Lang = data?.Lang;

    let initialState;

    if (popupOpenInterval === 'Everytime') {
        initialState = true;
    } else {
        initialState = closedOfferPopups.indexOf(popupID) === -1;
    }

    const [isOpen, setIsOpen] = useState(initialState);

    const closePopup = () => {
        if (
            closedOfferPopups.indexOf(popupID) === -1 &&
            popupOpenInterval !== 'Everytime'
        ) {
            closedOfferPopups.push(popupID);
            sessionStorage.setItem(
                sessionStorageKeys.CLOSED_OFFER_POPUPS,
                JSON.stringify(closedOfferPopups)
            );
        }
        setIsOpen(false);
    };

    let positionClass = '';

    if (popupVerticalAlign && popupHorrizontalAlign) {
        positionClass = `ab-offer-popup-cnt--${popupVerticalAlign
            .toLocaleLowerCase()
            .replace('middle', 'center')}-${popupHorrizontalAlign
            .toLocaleLowerCase()
            .replace('middle', 'center')}`;
    }

    const [isSuccess, setIsSuccess] = useState(false);

    const popupCntStyles = {
        backgroundColor: addHashToHexColor(popupBackgroundColor),
        borderColor: addHashToHexColor(popupBorderColor),
        height: popupHeight,
        width: popupWidth,
        marginTop: topMargin,
        marginBottom: bottomMargin,
        marginLeft: leftMargin,
        marginRight: rightMargin,
    };

    const popupInnerCntStyles = {
        borderRadius: popupBorderRadius,
    };

    // const popupCloseBtnStyles = {
    //     backgroundColor: addHashToHexColor(popupCloseButtonBackgroundColor),
    //     color: addHashToHexColor(popupCloseButtonColor),
    // };

    const popupLinkStyles = {
        backgroundColor: addHashToHexColor(popupButton1Background),
        borderColor: addHashToHexColor(popupButton1BorderColor),
        color: addHashToHexColor(popupButton1FontColor),
        fontSize: addHashToHexColor(popupButton1FontSize),
    };
    const { userBookingData } = useGetBookingData();
    const [errors, setErrors] = useState({});
    const [email, setEmail] = useState('');
    const [fullName, setFullName] = useState('');
    const [acceptTermsAndConditions, setAcceptTermsAndConditions] =
        useState(false);

    const validateInputs = () => {
        const errors = {};

        const emailRegex =
            // eslint-disable-next-line no-useless-escape
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        if (!email) {
            errors.email = Lang?.fillInYourEmail;
        } else if (!email.match(emailRegex)) {
            errors.email = Lang?.pleaseEnterValidEmail;
        }

        return errors;
    };

    const currentUrl = window.location.href;

    const handleSubmit = async (event) => {
        event.preventDefault();
        const errors = validateInputs();

        if (!isEmpty(errors)) {
            setErrors(errors);
            return;
        }

        const cookie = getCookie(COOKIE_NAME);

        try {
            const response = await axios.post(btnUrl, {
                curCode: userBookingData?.currency,
                lang: userBookingData?.localeLanguage,
                key: email,
                fullName,
                cookie,
                popupID,
                currentUrl,
            });

            if (response?.data?.toLowerCase() === '') {
                toast.success(Lang?.verifyEmailMsg, {
                    autoClose: true,
                    theme: 'colored',
                });
                setIsSuccess(true);
            } else if (response?.data?.toLowerCase() === 'Error') {
                toast.error('Something went wrong try again', {
                    autoClose: true,
                    theme: 'colored',
                });
                setIsSuccess(false);
            }
        } catch (error) {
            toast.error(Lang?.networkError, {
                autoClose: true,
                theme: 'colored',
            });
        }
    };

    return (
        isOpen && (
            <div
                className={`ab-offer-popup-cnt ${positionClass} ${extraClass}`}
                style={popupCntStyles}
            >
                <button
                    className="ab-offer-popup-close-btn"
                    // style={popupCloseBtnStyles}
                    onClick={closePopup}
                >
                    <FaTimes />
                </button>

                <div
                    className="ab-offer-predifined-inner-cnt"
                    style={popupInnerCntStyles}
                >
                    {imageUrl && (
                        <div
                            className="ab-offer-popup-header"
                            style={{ display: 'flex' }}
                        >
                            <div className="ab-offer-predifined-image">
                                <img
                                    src={imageUrl}
                                    alt=""
                                    style={{ height: '100%' }}
                                />
                            </div>
                        </div>
                    )}
                    <form
                        className="ab-offer-predifined-form"
                        onSubmit={handleSubmit}
                    >
                        <div
                            className="ab-offer-predifined-body"
                            style={popupInnerCntStyles}
                        >
                            <h4
                                className="ab-offer-popup-title"
                                dangerouslySetInnerHTML={{ __html: title }}
                            ></h4>
                            <div
                                className="ab-offer-predifined-desc"
                                dangerouslySetInnerHTML={{ __html: desc }}
                            ></div>
                            {isSuccess ? (
                                <>
                                    <div
                                        dangerouslySetInnerHTML={{
                                            __html: popupButton1MessageAfterPress,
                                        }}
                                    ></div>
                                </>
                            ) : (
                                <>
                                    <Checkbox
                                        className="ab-offer-predifined-checkbox"
                                        onChange={(event) =>
                                            setAcceptTermsAndConditions(
                                                event.target.checked
                                            )
                                        }
                                        isChecked={acceptTermsAndConditions}
                                    >
                                        Click here to agree to our{' '}
                                        <a
                                            href={termsAndConditionsUrl}
                                            className="ab-offer-predifined-a-link"
                                            target="blank"
                                        >
                                            terms and conditions.
                                        </a>
                                    </Checkbox>
                                    <Input
                                        type="text"
                                        placeholder="Full Name"
                                        value={fullName}
                                        isRequired
                                        id="track-prices-fullname"
                                        autoFocus
                                        onChange={(event) =>
                                            setFullName(event.target.value)
                                        }
                                        ref={(el) => {
                                            applyImportantStyles(el, {
                                                border: '1px solid #ccc !important;',
                                                padding: '10px !important;',
                                            });
                                        }}
                                    />
                                    <div className="ab-offer-predifined-input-button-wrapper">
                                        <Input
                                            className="ab-offer-predifined-small-input"
                                            type="email"
                                            placeholder={Lang?.yourEmailAddress}
                                            value={email}
                                            isRequired
                                            id="track-prices-email"
                                            autoFocus
                                            isInvalid={Boolean(errors?.email)}
                                            errorMsg={errors.email}
                                            onChange={(event) =>
                                                setEmail(event.target.value)
                                            }
                                            ref={(el) => {
                                                applyImportantStyles(el, {
                                                    border: '1px solid #ccc !important;',
                                                    padding: '10px !important;',
                                                });
                                            }}
                                        />

                                        <button
                                            type="submit"
                                            className="ab-offer-predifined-link"
                                            style={popupLinkStyles}
                                            id="ab-offer-predifined-submit"
                                            disabled={!acceptTermsAndConditions}
                                        >
                                            {btnText}
                                        </button>
                                    </div>
                                </>
                            )}
                        </div>
                    </form>
                </div>
            </div>
        )
    );
};

// TODO: MAKE THIS BETTER
PredifinedPopUp.propTypes = {
    props: PropTypes.object,
    imageUrl: PropTypes.string,
    title: PropTypes.string,
    desc: PropTypes.string,
    btnText: PropTypes.string,
    btnUrl: PropTypes.string,
    extraClass: PropTypes.string,
};

export default PredifinedPopUp;
